import { CANCEL_EDITING_REQUEST } from '../../shared/actions/shared.actions'
import { PayloadedAction } from '../../shared/types'
import {
  CLEAR_ISSUE_OPTION_SELECTED,
  ISSUE_OPTIONS,
  ISSUE_OPTIONS_RESET,
  SET_CLEAR_ISSUE,
  SET_ISSUE_OPTION_SELECTED,
  SET_PACE_SETTER_STEP
} from './issue.actions'

import {
  IssueOptionSelected,
  IssueOptionsResponse
} from './issue.types'

export interface PaceSetterState {
  stepIndex: number
  issueOptions: IssueOptionsResponse | null
  issueOptionSelected: IssueOptionSelected | null
  loadFailed: boolean
}

export const initialState: PaceSetterState = {
  stepIndex: 0,
  issueOptions: null,
  issueOptionSelected: null,
  loadFailed: false,
}

export function reducer(
  state: PaceSetterState | undefined = initialState,
  action: PayloadedAction & { index?: number }
): PaceSetterState {
  switch (action.type) {
    case SET_PACE_SETTER_STEP:
      return {
        ...state,
        stepIndex: +action.index,
      }
    case CANCEL_EDITING_REQUEST: {
      return {
        ...initialState,
      }
    }
    case SET_CLEAR_ISSUE: {
      return {
        ...state,
        issueOptionSelected: initialState.issueOptionSelected,
      }
    }
    case ISSUE_OPTIONS.REQUEST: {
      return {
        ...state,
        loadFailed: false,
      }
    }
    case ISSUE_OPTIONS_RESET: {
      return {
        ...state,
        issueOptions: initialState.issueOptions,
        loadFailed: false,
      }
    }
    case ISSUE_OPTIONS.SUCCESS: {
      return {
        ...state,
        issueOptions: action.payload,
      }
    }
    case ISSUE_OPTIONS.FAILURE: {
      return {
        ...state,
        loadFailed: true,
      }
    }
    case SET_ISSUE_OPTION_SELECTED: {
      return {
        ...state,
        issueOptionSelected: action.payload,
      }
    }
    case CLEAR_ISSUE_OPTION_SELECTED: {
      return {
        ...state,
        issueOptionSelected: initialState.issueOptionSelected,
      }
    }
    default:
      return state
  }
}
